// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { formatISO } from 'date-fns';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import FocusPointsArray from '../shared/FocusPointsArray';
import EmentorArray from '../shared/EmentorArray';
import ReadingAttribution from '../shared/ReadingAttribution';

const PEReadingAuthenticMaterial = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Reading" instructions="Fill in the data for the Reading." />
      <Controller 
        control={control}
        name="content.core"
        render={({ field }) => <ReadingAttribution targetObj="content.core" inputDir={inputDir} errors={errors.content?.core} {...{control }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Focus Points" instructions="Using the following controls add 1 focus point per focus point needed." />
      <Controller
        control={control}
        name="content.focus_points"
        render={({ field }) => <FocusPointsArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <NumberedHeading number="3" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default PEReadingAuthenticMaterial;